import React from "react";
import StudentResourceTemplate from "./StudentResourceTemplate";

export const resourcePage = {
  id: "cse-resources",
  department: "Computer Science & Engineering",
  short: "CSE",
  description: "Student Resources for the Department of Computer Science & Engineering.",
  resourceSet: "aiml",
  sections: [
    {
      title: "IA Test Syllabus",
      items: [
        {
          label: "IA Test Syllabus",
          href: "https://drive.google.com/drive/folders/11OtSTsRjJS-4bEwvBMaXZj-MlTqmTyYV?usp=drive_link",
        },
      ],
    },
    { title: "Timetable", items: [
        // {
        //   label: "1st Semester TimeTable",
        //   href: "#",
        // },
        // {
        //   label: "2nd Semester TimeTable",
        //   href: "#",
        // },
        // {
        //   label: "3rd Semester TimeTable",
        //   href: "#",
        // },
        {
          label: "4th(A) Semester TimeTable",
          href: "/student_resources/CSE/TimeTable/4th-sem-A-div-time-table.pdf",
        },
        {
          label: "4th(B) Semester TimeTable",
          href: "/student_resources/CSE/TimeTable/4th-sem-B-div-Time-Table.pdf",
        },
        // {
        //   label: "5th Semester TimeTable",
        //   href: "#",
        // },
        {
          label: "6th(A) Semester TimeTable",
          href: "/student_resources/CSE/TimeTable/6th-A-Time-table-2.pdf",
        },
        {
          label: "6th(B) Semester TimeTable",
          href: "/student_resources/CSE/TimeTable/6th-B-time-table-1.pdf",
        },
    ] },
    { title: "Academic Calendar", items: [
        {
          label: "6th & 8th Sem COE",
          href: "/student_resources/CSE/COE/COE_6-8_EvenSem(25-26).pdf",
        },
        {
          label: "4th Sem COE",
          href: "/student_resources/CSE/COE/Department-Calendar-4th-Even-Sem-2025-2026.pdf",
        },
    ] },
    // {
    //   title: "Lab Manuals",
    //   items: [
    //     {
    //       label: "Lab Manuals",
    //       href: "#",
    //     },
    //   ],
    // },
    {
      title: "Question Papers & Solutions",
      items: [
        {
          label: "Question Paper and Solution",
          href: "https://drive.google.com/drive/folders/1X0uyhi1tyBLkHHiA_-snpaRS1JqRfT2_?usp=drive_link",
        },
      ],
    }, 
    {
      title: "Add-On Subjects",
      items: [
        {
          label: "Add-On Course Syllabus",
          href: "https://drive.google.com/drive/folders/1L7WOax4WN-XE3c0soJvE_H74xf8RtCtU?usp=drive_link",
        },
      ],
    },
    // {
    //   title: "Published Papers & Patents",
    //   items: [
    //     {
    //       label: " INTEGRATED LEGAL CASE ANALYSIS AND DOCUMENT GENERATION SYSTEM USING RETRIEVAL-AUGMENTED AI MODELS ",
    //       href: "/resources/student-resources/aiml/published-papers-patents/viewjournal-396.pdf",
    //     },
    //     {
    //       label: " NETWORK TRAFFIC ANALYSIS FOR SECURITY ANOMALY ",
    //       href: "/resources/student-resources/aiml/published-papers-patents/viewjournal-799.pdf",
    //     },
    //     {
    //       label: " CROWD SENSE: A REAL-TIME SYSTEM FOR CROWD ANALYTICS",
    //       href: "/resources/student-resources/aiml/published-papers-patents/viewjournal-883.pdf",
    //     },
    //     {
    //       label: " AI-DRIVEN MOBILE FORENSICS",
    //       href: "/resources/student-resources/aiml/published-papers-patents/viewjournal-1145.pdf",
    //     },
    //     {
    //       label: " AI-BASED TEXT TO 3D MODEL GENERATOR",
    //       href: "/resources/student-resources/aiml/published-papers-patents/viewjournal-1793-793.pdf",
    //     },
    //   ],
    // },
    {
      title: "Mentor List",
      items: [
        {
          label: "2025-26",
          href: "/student_resources/CSE/MentorMentee/students-counselors-list.pdf",
        },
      ],
    },
  ],
};

const CSEResources = () => <StudentResourceTemplate resourcePage={resourcePage} />;

export default CSEResources;
